import { useNotetakerEntitled } from 'features/meeting_intelligence'

import { useNotetakerMarketEligibility } from './useNotetakerMarketEligibility'

/** Commerce / upsell surfaces — market-eligible users who are not yet entitled. */
export const useNotetakerUpsellUIVisible = () => {
  const {
    isEntitled,
    isLoading: isEntitlementLoading,
    isError: isEntitlementError
  } = useNotetakerEntitled()
  const { isEligible: marketEligible, isLoading: isMarketLoading } = useNotetakerMarketEligibility()

  const isLoading = isEntitlementLoading || isMarketLoading
  const isVisible = !isLoading && !isEntitlementError && marketEligible && !isEntitled

  return { isVisible, isLoading }
}
